import { EmailValidation, PhoneNumberValidation } from 'utils/helper';
import { FormattedMessage } from 'react-intl';

const CheckValidation = (value) => {
  const formError = {
    submit: true,
    providerName: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    email: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    password: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    mobileNumber: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    state: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    city: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    stateId: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    cityId: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    phone: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    country_code: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    providerType: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    highestQualification: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    highestQualificationId: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    latitude: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    longitude: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    streetAddress: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    zipCode: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    title: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    titleSlug: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    bio: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    profileId: {
      error: '',
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    stateCode: {
      error: {},
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    stateCodeId: {
      error: [],
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    amount: {
      error: {},
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    uploadListId: {
      error: [],
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    practiceName: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    bioText: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    languages_slug: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    sub_practice_name: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    question_text: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    questionType: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    question_type_id: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    category: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    questionnaire_id: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    switchValue: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    categoryName: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    rejectReason: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    confirmPassword: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
  };

  for (let key in value) {
    const fieldValue = value[key];
    const isEmpty =
      fieldValue === undefined ||
      fieldValue === null ||
      (typeof fieldValue === 'string' && fieldValue.trim() === '') ||
      (Array.isArray(fieldValue) && fieldValue.length === 0);

    if (formError.hasOwnProperty(key)) {
      if (isEmpty) {
        formError[key].error = true;
        formError.submit = false;
      }

      if (key === 'email' && fieldValue && !EmailValidation(fieldValue)) {
        formError[key].error = true;
        formError.submit = false;
        formError[key].errorMessage = (
          <FormattedMessage id="Please Enter Valid Email!" />
        );
      }
    }
  }

  return formError;
};

export default CheckValidation;
